import { MutatePlayerClubSection } from '@/features/player/components/mutate-player/mutate-player-club-section';

import { MutatePlayerContactSection } from '@/features/player/components/mutate-player/mutate-player-contact-section/mutate-player-contact-section';
import { MutatePlayerFooter } from '@/features/player/components/mutate-player/mutate-player-footer';
import { MutatePlayerHeader } from '@/features/player/components/mutate-player/mutate-player-header';
import { MutatePlayerEditTabs } from '@/features/player/components/mutate-player/mutate-player-edit-tabs';
import { MutatePlayerProfileSection } from '@/features/player/components/mutate-player/mutate-player-profile-section';

export * from './constants';
export * from './types';

const MutatePlayerView = {
  Header: MutatePlayerHeader,
  EditTabs: MutatePlayerEditTabs,
  ProfileSection: MutatePlayerProfileSection,
  ContactSection: MutatePlayerContactSection,
  ClubSection: MutatePlayerClubSection,
  Footer: MutatePlayerFooter,
};

export default MutatePlayerView;
